import axios from 'axios';

const getAuthHeaders = (userType) => {
    let token = '';
    if (userType === 'Activity') token = localStorage.getItem('token_partner_activities');
    if (userType === 'Restaurant') token = localStorage.getItem('token_partner_restaurant');
    if (userType === 'Shop') token = localStorage.getItem('token_partner_shop');
    
    return {
        headers: {
            Authorization: `Bearer ${token}`
        }
    };
};

export const walletService = {
    getWalletDetails: async (userType, userId) => {
        const response = await axios.get(
            `${process.env.REACT_APP_BASE_URL}/wallet/${userType}/${userId}`, 
            getAuthHeaders(userType)
        );
        return response.data;
    },
    requestRedemption: async (userType, data) => {
        const response = await axios.post(
            `${process.env.REACT_APP_BASE_URL}/wallet/redeem`, 
            data,
            getAuthHeaders(userType)
        );
        return response.data;
    }
};
